import component from './generalButton';

export default component;